import {getViaMParticleInstance, MParticleEventPayload} from "via-city-tools-m-particle";

export enum MParticleEventName {
    LOGIN_SUCCESS = "LOGIN_SUCCESS",
    LOGIN_FAILURE = "LOGIN_FAILURE",
    FORGOT_PASSWORD_SEND_EMAIL_SUCCESS = "FORGOT_PASSWORD_SEND_EMAIL_SUCCESS",
    FORGOT_PASSWORD_SEND_EMAIL_FAILURE = "FORGOT_PASSWORD_SEND_EMAIL_FAILURE",
    PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS",
    PASSWORD_RESET_FAILURE = "PASSWORD_RESET_FAILURE",
    CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS",
    CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE",
    MFA_SETUP_SUCCESS = "MFA_SETUP_SUCCESS",
    MFA_SETUP_FAILURE = "MFA_SETUP_FAILURE",
    SSO_LOGIN = "SSO_LOGIN"
}

export interface MParticleEventParams {
    username?: string;
    errorCode?: string;
    errorMessage?: string;
    mfaType?: string;
    ssoProvider?: string;
}



export const logEvent = (eventName: string, screen: string, params: MParticleEventParams) => {
    if (!getViaMParticleInstance()) {
        return;
    }
    const payload: MParticleEventPayload = {
        eventName: eventName,
        screen: screen,
        params: params,
    }
    getViaMParticleInstance().logEvent(payload);
}

export const reporterInstance = getViaMParticleInstance();
